import React from 'react';
import { PROMO_END_AT } from '../data/config';
import { useCountdown } from '../hooks/useCountdown';
import { formatCountdown, getCuposPercent } from '../utils/promo';
export function TopBar() {
  const timeLeft = useCountdown(PROMO_END_AT);
  const percent = getCuposPercent();
  return <div className="sticky top-0 z-50 w-full bg-brand-violet text-white" data-id="element-230" data-mp="1t4zax494763m">
      <div className="mx-auto flex max-w-page items-center justify-between gap-3 px-4 py-2.5 md:px-8" data-id="element-231" data-mp="1t729icoc27jy">
        <p className="flex min-w-0 flex-wrap items-center gap-x-4 gap-y-1 text-[13px] sm:text-sm md:text-[15px]" data-id="element-232" data-mp="2quaorpxqqkdi">
          <span className="font-bold" data-id="element-233" data-mp="2h2epwcntyq88">🎃 Prepará Halloween en familia</span>
          <span className="hidden text-white/80 sm:inline" data-id="element-234" data-mp="2h0lkt1sv8e2c">2 tomos + 5 bonus</span>
          {timeLeft && <span className="w-full sm:w-auto" data-id="element-235" data-mp="2c1h9a4igy48u">
              ⏰ La oferta termina en:{' '}
              <strong className="tabular-nums text-brand-orange" data-id="element-236" data-mp="39kaductkzzgx">{formatCountdown(timeLeft)}</strong>
            </span>}
          {percent !== null && <span className="text-white/90" data-id="element-237" data-mp="25hhtjnniwhc">
              <strong className="text-brand-orange" data-id="element-238" data-mp="25rc3jfqbpsu">{percent}%</strong> de cupos tomados
            </span>}
        </p>
        <a href="#oferta" className="shrink-0 whitespace-nowrap rounded-xl border-b-2 border-brand-orangeDark bg-brand-orange px-3 py-2 text-xs font-bold text-brand-violet transition-[transform,background-color] duration-150 ease-out hover:-translate-y-px hover:bg-brand-orangeLight focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-brand-violet sm:text-sm" data-id="element-239" data-mp="68xeuh3muyuk">
          VER KIT →
        </a>
      </div>
    </div>;
}